import { FC } from 'react'

type Props = {
  title: string
  options: string[]
}

const Component: FC<Props> = ({ title, options }) => {
  return (
    <div>
      <h3 className="text-xl font-semibold text-secondary-700">{title}</h3>
      <div className="flex flex-wrap gap-8 mt-4">
        {options.map((o, idx) => {
          return (
            <div key={o} className="flex gap-3 items-center">
              <div className="w-10 h-10 rounded-full bg-primary-800 text-white text-2xl font-bold italic text-center align-middle flex justify-center items-center">
                <span>{idx + 1}</span>
              </div>
              <p>{o}</p>
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default Component
